var _circle, _g, _path, _circle2, _path2, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13, _g14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNorthKorea(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 512 512",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    fill: "#f0f0f0",
    r: 256
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#0052b4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m256 0c-77.591 0-147.114 34.524-194.061 89.043h388.121c-46.946-54.519-116.469-89.043-194.06-89.043z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m450.061 422.957h-388.122c46.947 54.519 116.47 89.043 194.061 89.043s147.114-34.524 194.061-89.043z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m474.426 122.435h-436.852c-23.829 38.885-37.574 84.618-37.574 133.565s13.745 94.681 37.574 133.565h436.852c23.829-38.884 37.574-84.618 37.574-133.565s-13.745-94.68-37.574-133.565z",
    fill: "#d80027"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 157.496,
    cy: 256,
    fill: "#f0f0f0",
    r: 98.504
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m157.496 157.496 22.101 68.021h71.638l-57.977 42.042 22.274 68.224-58.036-42.242-57.948 42.163 22.186-68.145-57.925-42.042h71.585z",
    fill: "#d80027"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNorthKorea);
export default __webpack_public_path__ + "static/media/northKorea.94de0ff4b384b0d18ebc3aeadeb1a05a.svg";
export { ForwardRef as ReactComponent };